import { Book, Tag } from '@readcloud/data';
import React from 'react';

type ContextType = {
  mediaContent: Book[];
  tagsContent: Tag[];
};
export const AnnotationsContext = React.createContext<ContextType | undefined>(
  undefined
);
